(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ACE_PPH_UI_Components"] = factory();
	else
		root["ACE_PPH_UI_Components"] = factory();
})(window, function() {
return 